import React from "react";
import { LiaUser } from "react-icons/lia";

function Picture({
  showImage,
  iconSize,
  iconColor,
  imgHeight,
  imgWidth,
  imgBorder,
  showborder,
}) {
  //   const [showAddIcon, setShowAddIcon] = useState(true);

  return (
    <div className="w-100 d-flex justify-content-center">
      <div className="w-100 d-flex justify-content-center">
        <div
          style={{
            position: "relative",
            // backgroundColor: hovering ? "rgba(0, 0, 0, 0.5)" : "#ededed",
            backgroundColor: "#ededed",
            width: imgWidth,
            height: imgHeight,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: imgBorder,
            userSelect: "none",
          }}
        >
          {showImage ? (
            <img
              src={showImage}
              className="w-100 h-100"
              style={{ borderRadius: imgBorder }}
              alt="profile"
            />
          ) : (
            <LiaUser size={iconSize} color={iconColor} />
          )}
        </div>
      </div>
    </div>
  );
}

export default Picture;
